/// <amd-module name="Wit/WorkItemLinksRegistration/LinkUtils" />
import { format } from "VSS/Core/Util/String";
import * as Resources from "Wit/WorkItemLinksRegistration/Resources";
import { LinkTypeFieldIds, RegisteredLinkTypeNames, ToolIds } from "./Constants";
import { ILinkIdentifier, IResolvedLinkDisplayData } from "./Contracts";

export function getLinkTypeDisplayName(linkType: string): string {
    switch (linkType) {
        case RegisteredLinkTypeNames.Related:
            return Resources.LinkTypeRelated;
        case RegisteredLinkTypeNames.Hyperlink:
            return Resources.LinkTypeHyperlink;
        case RegisteredLinkTypeNames.Changeset:
            return Resources.LinkTypeChangeset;
        case RegisteredLinkTypeNames.VersionedItem:
            return Resources.LinkTypeVersionedItem;
        case RegisteredLinkTypeNames.Commit:
            return Resources.LinkTypeCommit;
        case RegisteredLinkTypeNames.Branch:
            return Resources.LinkTypeBranch;
        case RegisteredLinkTypeNames.Tag:
            return Resources.LinkTypeTag;
        case RegisteredLinkTypeNames.PullRequest:
            return Resources.LinkTypePullRequest;
        case RegisteredLinkTypeNames.ResultAttachment:
            return Resources.LinkTypeResultAttachment;
        case RegisteredLinkTypeNames.TestResult:
            return Resources.LinkTypeTestResult;
        case RegisteredLinkTypeNames.Test:
            return Resources.LinkTypeTest;
        case RegisteredLinkTypeNames.Storyboard:
            return Resources.LinkTypeStoryboard;
        case RegisteredLinkTypeNames.Build:
            return Resources.LinkTypeBuild;
        case RegisteredLinkTypeNames.FoundInBuild:
            return Resources.LinkTypeFoundInBuild;
        case RegisteredLinkTypeNames.IntegratedInBuild:
            return Resources.LinkTypeIntegratedInBuild;
        case RegisteredLinkTypeNames.WikiPage:
            return Resources.LinkTypeWikiPage;
        case RegisteredLinkTypeNames.GitHubPullRequestLinkType:
            return Resources.LinkTypeGitHubPullRequest;
        case RegisteredLinkTypeNames.GitHubCommitLinkType:
            return Resources.LinkTypeGitHubCommit;
        case RegisteredLinkTypeNames.GitHubIssueLinkType:
            return Resources.LinkTypeGitHubIssue;
        case RegisteredLinkTypeNames.ReleaseEnvironment:
            return Resources.LinkTypeReleaseEnvironment;
        default:
            // TODO:Replat
            /*
            // If it is not one of the registered link types, it probably came from an extension.
            const linkData = getContributedLinkName(linkType, store);
            return (linkData && linkData.linkTypeName) ? linkData.linkTypeName : Resources.LinksControlUnknownLinkTypeText;
            */
            return linkType;
    }
}

export function getToolDisplayName(toolId: string, isRemote?: boolean): string | undefined {
    switch (toolId) {
        case ToolIds.VersionControl:
        case ToolIds.Git:
            return Resources.LinkToolTypeCode;
        case ToolIds.TestManagement:
            return Resources.LinkToolTypeTest;
        case ToolIds.Requirements:
            return Resources.LinkToolTypeRequirements;
        case ToolIds.TeamBuild:
            return Resources.LinkToolTypeBuild;
        case ToolIds.Wiki:
            return Resources.LinkToolTypeWiki;
        case ToolIds.GitHub:
            return Resources.LinkToolTypeGitHub;
        default:
            return isRemote ? Resources.LinkToolTypeRemoteWork : Resources.LinkToolTypeWork;
    }
}

export function isSameLinkIdentifier(a: ILinkIdentifier, b: ILinkIdentifier): boolean {
    return a.FldID === b.FldID && a.ExtID === b.ExtID && a.FilePath === b.FilePath && a.ID === b.ID && a.OriginalName === b.OriginalName;
}

export function makePlaceholderForUnresolvedLinkIdentifier(linkIdentifier: ILinkIdentifier, linkTypeName?: string, witLinkTypeEnd?: string): IResolvedLinkDisplayData | undefined {
    const linkType =
        linkIdentifier.FldID === LinkTypeFieldIds.ExternalLink
            ? linkIdentifier.OriginalName
            : linkIdentifier.FldID === LinkTypeFieldIds.WorkItem
            ? RegisteredLinkTypeNames.Related
            : linkIdentifier.FldID === LinkTypeFieldIds.Hyperlink
            ? RegisteredLinkTypeNames.Hyperlink
            : undefined;

    if (!linkType) {
        return undefined;
    }

    return {
        linkIdentifier,
        icons: [{ iconName: "AlertSolid", className: "error-text icon-margin" }],
        id: linkIdentifier.ID ? linkIdentifier.ID.toString() : linkIdentifier.FilePath ?? "ID",
        displayId: linkIdentifier.ID ? linkIdentifier.ID.toString() : "",
        title: format(Resources.ErrorLinkCouldNotBeRead, linkTypeName || getLinkTypeDisplayName(linkType)),
        tool: linkIdentifier.tool,
        linkTypeDisplayName: linkTypeName || getLinkTypeDisplayName(linkType),
        registeredLinkType: linkType,
        uri: "#",
        additionalData: {
            isPlaceholderForUnresolvedLinkIdentifier: true
        },
        witLinkTypeEnd,
    };
}

export function isPlaceholderForUnresolvedLinkIdentifier(link: IResolvedLinkDisplayData) {
    return link.additionalData?.isPlaceholderForUnresolvedLinkIdentifier;
}
